export const navData = {
    nowMenuIndex: 1,
    dataMenu:{},
    navIndex: 1,
    navSonIndex: -1,
}